import { useAuth } from "@/context/AuthContext";

/**
 * Returns the effective permission map for the current user.
 *
 * Phase 84.44 — Founder-only Access Management overhaul: `founder` is the
 * only role with automatic full access (baked into the backend's
 * `has_feature()`, mirrored in `user.permissions`). Admins are a normal
 * locked-down role now — everything here purely reflects the resolved
 * `user.permissions` map a Founder configures via Access Management.
 *
 * Usage:
 *   const can = usePermissions();
 *   if (can("finance")) { ... }
 */
export default function usePermissions() {
  const { user } = useAuth();
  const map = user?.permissions || {};

  return function can(feature) {
    if (!user) return false;
    return !!map[feature];
  };
}
